module.exports = __webpack_public_path__ + "static/media/stability-improvement.bd498d4e.svg";